import logo from './logo.svg';
import './App.css';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { AuthProvider, RequireAuth } from "./AuthProvider.tsx";
import CampaignsOverview from "./views/CampaigOverview.tsx";
import CampaignWizzard from "./views/CampaignWizzard.tsx";
import CampaignDetail from "./views/CampaignDetail.tsx";
import Settings from "./views/Settings.tsx";
import Licenses from "./views/Licenses.tsx";
import OrganizationSettings from "./views/OrganizationSettings.tsx";
import AcceptOrganizationInvitation from "./views/AcceptOrganizationInvitation.tsx";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <RequireAuth fallback={<div className="p-6">Redirecting to login…</div>}>
          <Routes>
            <Route path="/" element={<CampaignsOverview />} />
            <Route path="/campaigns/new" element={<CampaignWizzard />} />
            <Route path="/campaigns/edit/:id" element={<CampaignWizzard />} />
            <Route path="/campaigns/:id" element={<CampaignDetail />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/licenses" element={<Licenses />} />
            <Route path="/settings/organization" element={<OrganizationSettings />} />
            <Route path="/invitations/:token" element={<AcceptOrganizationInvitation />} />
          </Routes>
        </RequireAuth>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
